import styled from 'styled-components'

import { helpers } from 'styles'

import { Location } from './Location'
import { Shared } from './Shared'

const getTransform = (location: Location) => {
	switch (location) {
		case Location.Top:
			return 'translate(-50%, -5px)'
		case Location.Bottom:
			return 'translate(-50%, 5px)'
		case Location.Right:
			return 'translate(5px, 50%)'
		case Location.Left:
			return 'translate(-5px, 50%)'
	}
}

type Props = {
	location: Location
	transitionInDelay: number
	maxWidth: number
}

export const Container = styled(Shared)<Props>`
	padding: 10px 18px;
	min-width: 50px;
	max-width: ${({ maxWidth }) => maxWidth}px;
	width: max-content;
	border-radius: 4px;
	font-size: ${helpers.font.size.base};
	background-color: ${helpers.color.cardBackground};
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
	color: ${helpers.color.text};
	text-align: center;
	white-space: pre-wrap;
	transform: ${({ location }) => getTransform(location)} scale(0.5);

	#tooltip-wrapper:hover & {
		transition-delay: ${({ transitionInDelay }) => transitionInDelay}ms;
		transform: ${({ location }) => getTransform(location)} scale(1);
		visibility: visible;
		opacity: 1;
	}
`
